export default __webpack_public_path__ + "static/FeaturesBannerImg-ea7917a06e7173702501f7efce51bbeb.png";